import { Injectable } from '@angular/core';
import { GetApplicationResponseModel } from 'src/app/models/applications.model';

@Injectable()
export class ContactsService {
  private _contactId!: number;

  constructor() {
  }

  get contactId(): number {
    return this._contactId;
  }

  set contactId(value: number) {
    this._contactId = value;
  }

  populateServiceWithGetApplicationResponseData(response: GetApplicationResponseModel): void {
    const primaryContact = response.contacts.find(c => c.primaryContact);

    if (primaryContact) {
      this.contactId = primaryContact.id;
    }
  }
}
